var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ButtonComponent',{staticClass:"list-field-link",attrs:{"icon":['fal', 'external-link'],"tag":"a","href":_vm.url,"target":"_blank"},on:{"click":function($event){$event.stopPropagation();return (() => ({})).apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }